export const ARCHIVED_CUSTOMER_ORDER_END_POINT_URL = '/v2/archived-customer-order';
export const CUSTOMER_ORDER_END_POINT_URL = '/v2/customer-order';
export const CHECK_ORDERS_FOR_SITES_ENDPOINT_URL: string = '/v2/site/orders';
export const CUSTOMER_MONTH_INVOICE_URL: string = '/v2/customer-month-invoice';
export const EXPORT_TO_EXCEL_URL = '/invoice/export-xlsx';
export const EXPORT_CUSTOMER_ORDER_TO_EXCEL = '/v2/customer-order/export-xlsx';
export const EXPORT_ARCHIVED_CUSTOMER_ORDER_TO_EXCEL = '/v2/archived-customer-order/export-xlsx';
export const SITES_WITHOUT_ORDERS_END_POINT_URL = '/v2/site/without-orders';
export const ACTIVE_CUSTOMERS_WITH_SITES_END_POINT_URL = '/v2/customer/active-with-sites';
export const CUSTOMER_OPTIONS_END_POINT_URL = '/v2/customer/order-options';
export const SITE_ORDER_OPTIONS_END_POINT_URL = (siteId: string): string =>
  `/v2/site/${siteId}/order-options`;
export const SCHEDULED_MEALS_ENDPOINT_URL = '/v2/scheduled-meals';
export const CYCLE_MENUS_ENDPOINT_URL = '/v2/cycle-menus';
export const SITE_ENDPOINT_URL = '/v2/site';
